/**
 * Copyright (c) 2019-2021 2022 AIGIA All Rights Reserved.
 */

"use strict";

import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from "@angular/core";
import {FloatingComponent} from "../floating/floating.component";
import {TranslateService} from "@ngx-translate/core";

/**
 * todo
 */
@Component({
	selector: "aigia-line-chart",
	templateUrl: "./line-chart.component.html",
	styleUrls: ["../floating/floating.component.css", "./line-chart.component.css"],
})

export class LineChartComponent extends FloatingComponent implements OnChanges, OnInit {

	@Input() public locked: boolean = false;
	@Input() public size: number[] = [];
	@Input() public shots: any[] = [];

	public title: string = "Line Chart";

	public name: string = "スコア";

	public progress = false;

	public dataSource: any[] = [];

	public animations: boolean = true;
	public xAxisLabel: string = "";
	public yAxisLabel: string = "";

	@Output() public progrssChange = new EventEmitter<boolean>();

	public colorScheme = {
		domain: ["#1CBCD8", "#FF8D60", "#FF586B", "#5c6bc0", "#3d5afe", "#4caf50", "#673ab7"],
	};

	constructor(
		public translate: TranslateService,
	) {
		super();
	}

	/**
	 * todo
	 */
	private score(shot: any): number {
		let result: number = 0;
		if (shot.platform) {
			if (shot.platform.description) {
				if (shot.platform.description.score) {
					result = Math.floor(shot.platform.description.score);
				}
			}
		}
		return result;
	}

	/**
	 * @returns none
	 */
	public ngOnChanges(changes: any): void {
		Object.keys(changes).forEach((propName) => {
			switch (propName) {
				case "visible":
				case "shots":
					if (this.visible) {
						this.draw(this.shots);
					}
					break;
				default:
					break;
			}
		});
	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {
	}

	/**
	 * @returns string
	 *
	 * for ngx-chart
	 *
	 */
	public xAxisFormat(value: any): string {
		return value.substr(11, 5);
	}

	/**
	 * @returns none
	 */
	public averageLine(shots: any[]): any {
		const score_line: any = {name: "Score", series: []};
		shots.forEach((shot) => {
			const score: number = this.score(shot);
			score_line.series.push({name: shot.name, value: score});
		});
		return score_line;
	}

	/**
	 * @returns none
	 */
	public draw(shots: any): void {
		this.Progress(true);
		try {
			const dataSource = [];
			dataSource.push(this.averageLine(shots));
			this.dataSource = dataSource;
		} finally {
			this.Progress(false);
		}
	}

	/**
	 * @returns none
	 */
	public Progress(progress: boolean): void {
		this.progrssChange.emit(progress);
	}

}


